import { createContext } from "react";

export const PageListContext = createContext()
export const PageListGlobalContext = createContext()